const descuentos = {
    "Rimac": {
      "Alto Riesgo": 0,
      "Mediano Riesgo": 15,
      "Bajo Riesgo 1": 12,
      "Bajo Riesgo 2": 19
    },
    "Pacifico": {
      "Alto Riesgo": 10,
      "Mediano Riesgo": 10,
      "Bajo Riesgo 1": 11,
      "Bajo Riesgo 2": 5
    },
    "La Positiva": {
      "Alto Riesgo": 7,
      "Mediano Riesgo": 12,
      "Bajo Riesgo 1": 0,
      "Bajo Riesgo 2": 10
    },
  }
export default descuentos